import NotificationsCustomItem from './NotificationsCustomItem';
export default NotificationsCustomItem;
